module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-md confirm-api-key-disable-modal\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> <h4><b>Are you sure you want to disable this key?</b></h4> </section> <form class=\"form-horizontal\"> <section class=\"modal-body\"> <p>")
    ; __append(escapeFn( locals.apiKey ))
    ; __append("</p> <p>Disabling an API key immediately renders it unusable.</p> </section> <section class=\"modal-footer ")
    ;  if(!locals.active) { 
    ; __append(" alert-info disabled ")
    ;  } 
    ; __append(" ")
    ;  if(locals.error) { 
    ; __append(" alert-danger ")
    ;  } 
    ; __append("\"> ")
    ;  if(locals.error) { 
    ; __append(" <p class=\"no-margin text-center\"> <strong>There was an error processing your request. ")
    ; __append(escapeFn( locals.error ))
    ; __append(". Please try again or contact us at support@easypost.com.</strong> </p> ")
    ;  } else if(locals.active) { 
    ; __append(" <button class=\"btn btn-red cancel\" type=\"button\">Cancel</button> <button class=\"btn btn-blue disable-api-key\" type=\"button\">Disable Key</button> ")
    ;  } else { 
    ; __append(" <p class=\"no-margin text-center\"><strong>Your API key is now disabled.</strong></p> ")
    ;  } 
    ; __append(" </section> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/confirm_api_key_disable_modal.ejs
// module id = 841
// module chunks = 1